export enum HealthieBaseUrl {
  Production = 'https://secure.gethealthie.com',
  Staging = 'https://securestaging.gethealthie.com'
}

export const healthieOrientationLinkPrefix =
  '/appointments/embed_appt?dietitian_id=3092387&provider_ids=[3092387]&appt_type_ids=[284763]';

export const healthiePeerSupporterLinkPrefix = (peerSupporterHealthieId: number) =>
  `/appointments/embed_appt?dietitian_id=${peerSupporterHealthieId}&provider_ids=[${peerSupporterHealthieId}]&appt_type_ids=[377265]`;
